export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const CONFIGURE = "CONFIGURE";
export const SET_OPERATIONS = "SET_OPERATIONS";
